import type { AiLabsWorkshop } from '../types'

// Per-workshop media + cross-fade colours, keyed by id. CDN art is `<slug>.jpg`
// (desktop) / `<slug>-mobile.jpg` (mobile). `dark` is the colour sampled from the
// art (the program-details page); `light` is Figma's palette for the parchment
// surface — see the AI Tiles frame, 3rd column of each row.
const CDN = 'https://static.masterclass.com'
const media = (slug: string, dark: string, light: string): AiLabsWorkshop => ({
  bgColors: { dark, light },
  desktopImageUrl: `${CDN}/executive-ai-lab-${slug}.jpg`,
  mobileImageUrl: `${CDN}/executive-ai-lab-${slug}-mobile.jpg`,
})

export const AI_LABS_WORKSHOPS: Record<string, AiLabsWorkshop> = {
  dataAnalysis: media('data-analysis-with-ai', '#281f1c', '#d8d5d1'),
  marketingCampaigns: media(
    'build-marketing-campaigns-with-ai',
    '#121d22',
    '#d3dfde',
  ),
  trainingAiAgents: media('training-ai-agents', '#1b2a25', '#d2dad7'),
  financialAnalysis: media(
    'financial-analysis-and-modeling',
    '#202821',
    '#e2e2d8',
  ),
  buildPrototypes: media('build-prototypes-with-ai', '#232d3c', '#d8ddd7'),
  answerEngineOptimization: media(
    'answer-engine-optimization',
    '#2b2329',
    '#dfdbdb',
  ),
  aiGovernance: media('ai-governance-safety-and-quality', '#2d3536', '#dfdfda'),
  agenticWorkflows: media('building-agentic-workflows', '#3b3834', '#e2e2dc'),
  customerResearch: media(
    'customer-research-with-synthetic-users',
    '#3d342a',
    '#e1deda',
  ),
  salesAgents: media('build-ai-agents-for-sales-and-gtm', '#212221', '#dededa'),
  storytelling: media(
    'storytelling-and-slide-decks-with-ai',
    '#2b2f32',
    '#dbdfe1',
  ),
  customerSupport: media('ai-for-customer-support', '#312b26', '#dedde3'),
}
